import React, { FC } from 'react';

import '../assets/styles/LayoutHeader.less';

const LayoutHeader: FC = ({ children }) => <header id="layout-header">{children}</header>;

export default LayoutHeader;
